import { CircularProgress, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Paper from '@mui/material/Paper';
import { consultingChCheckZipcode } from '_models/redux/consulting-zipcode/action';
import { cleanConsultingCheckZipcodeAction } from '_models/redux/consulting-zipcode/clean';
import { LayoutContext } from 'modules/layout/data/layoutContext';
import { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CustomDialog from 'widgets/component/CustomDialog';
import { ReactComponent as SearchIcon } from '../../../../../src/assets/icons/Navegation/lupa.svg';
import { icons, iconSearch } from '../menu/Styles/StylesIcons';
import MenuZipcodeInfoWidget from './MenuZipcodeInfoWidget';

const MenuCheckZipcodeWidget = (props) => {
  const { ConsultingcheckZipcodeObj, consultingChCheckZipcode } = props || {};

  const { payload, status, state } = ConsultingcheckZipcodeObj || {};

  const [detailError, setDetailError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [searchText, setSearchText] = useState('');

  const handleSearchClick = async () => {
    if (searchText.trim() !== '') {
      try {
        setIsLoading(true);
        await consultingChCheckZipcode({ zipcode: searchText });
      } catch (error) {
        console.error('Error al consultar ZIP code:', error);
      } finally {
        setSearchText(''); // Limpiar el input después de la búsqueda
        setIsDialogOpen(true);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (typeof payload !== 'undefined') {
      const errorDetail = payload?.response?.data?.detail || payload?.detail || null;

      if (state === 'error' || status > 299) {
        setDetailError(errorDetail);
      } else {
        setDetailError(null);
      }
      setIsDialogOpen(true);
      setIsLoading(false);
    }
  }, [payload, status, state]);

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const layoutContext = useContext(LayoutContext) || {};
  const { layoutVariables, methods } = layoutContext || {};
  const { open } = layoutVariables || {};
  const { layoutMethods } = methods || {};
  const { handleDrawerOpen } = layoutMethods || {};

  const sanitizeZipcodeInput = (value = '') => value.replace(/\D+/g, '');

  const isInputValid = /^\d{5,}$/.test(searchText);

  return (
    <>
      {open ? (
        <Paper
          component='form'
          sx={{
            p: '2px 4px',
            m: '10px',
            display: 'flex',
            alignItems: 'center',
            width: 215,
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder='Código Postal...'
            value={searchText}
            onChange={(e) => setSearchText(sanitizeZipcodeInput(e.target.value))}
            onPaste={(e) => {
              e.preventDefault();
              const pastedText = e.clipboardData.getData('text');
              setSearchText(sanitizeZipcodeInput(pastedText));
            }}
          />
          <IconButton
            type='button'
            sx={{ p: '10px' }}
            aria-label='search'
            onClick={handleSearchClick}
            disabled={!isInputValid}
            size='large'
          >
            <SearchIcon style={iconSearch} />
          </IconButton>
        </Paper>
      ) : !open ? (
        <>
          <IconButton
            type='button'
            sx={{ p: '10px', width: '100%' }}
            aria-label='search'
            onClick={handleDrawerOpen}
            size='large'
          >
            <SearchIcon style={icons} />
          </IconButton>
        </>
      ) : null}
      {isInputValid || searchText === '' ? null : (
        <Typography color='error' variant='caption' sx={{ ml: 2 }}>
          Se requieren al menos 5 caracteres numéricos.
        </Typography>
      )}
      {isLoading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1000,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!isLoading && (
        <CustomDialog
          title='Consulta de Cobertura'
          content={
            state === 'error' || status > 299 ? (
              <MenuZipcodeInfoWidget dataError={detailError} />
            ) : (
              <MenuZipcodeInfoWidget data={payload} />
            )
          }
          open={isDialogOpen}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth='sm'
        />
      )}
    </>
  );
};

/******/
/** Redux map state to props **/
const mapStateToProps = (state) => ({
  ConsultingcheckZipcodeObj: state.consultingCheckZipcode,
});

/** Redux map dispatch to props **/
const mapDispatchToProps = {
  consultingChCheckZipcode,
  cleanConsultingCheckZipcodeAction,
};

/** Export component connected to redux **/
export default connect(mapStateToProps, mapDispatchToProps)(MenuCheckZipcodeWidget);
